import React from 'react';
import Loader from '@/components/common/Loader';
import type IntegrationID from '@/constants/integrations/IntegrationID';
import type MailchimpTiers from '@/constants/integrations/MailchimpTiers';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const ConstituentExportChoiceDialogContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "constituent-export-choice-dialog" */
      './ConstituentExportChoiceDialogContent'
    ),
);

type ConstituentExportChoiceDialogProps = {
  onClose(): void;
  open: boolean;
  setDestination(destination: IntegrationID): void;
  setIsExportCSVModalActive(isActive: boolean): void;
  setIsExportDestinationModalActive(isActive: boolean): void;
  setMailchimpPricingTier(tier: MailchimpTiers): void;
};

export default function ConstituentExportChoiceDialog({
  setDestination,
  setIsExportCSVModalActive,
  setIsExportDestinationModalActive,
  setMailchimpPricingTier,
  ...dialogProps
}: ConstituentExportChoiceDialogProps) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        data-testid="constituent-export-choice-dialog"
        scroll="paper"
        {...dialogProps}
      >
        <ConstituentExportChoiceDialogContent
          setDestination={setDestination}
          setIsExportCSVModalActive={setIsExportCSVModalActive}
          setIsExportDestinationModalActive={setIsExportDestinationModalActive}
          setMailchimpPricingTier={setMailchimpPricingTier}
          {...dialogProps}
        />
      </LazyDialog>
    </React.Suspense>
  );
}
